










































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import poa_series from '@/mixins/axios/poa_series'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/

    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  show:true,
        columnasd:[
            
            
           
            {
                tag:'ano',
                data:'ano',
                active:true
            },
             {
                tag:'estatus',
                data:'estatus',
                active:true
            },
        
            {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
        ],


        id:null as any,

      ano:2021 as any,
      estatus:'Activo' as any,

estatus_list:[
    {
        id:'Activo',
        nombre:'Activo'
    },
    {
        id:'Inactivo',
        nombre:'Inactivo'
    }
],

anos_list:[
    {
        id:2015,
        nombre:2015
    },
    {
        id:2016,
        nombre:2016
    },
     {
        id:2017,
        nombre:2017
    },
    {
        id:2018,
        nombre:2018
    },
    {
        id:2019,
        nombre:2019
    },
    {
        id:2020,
        nombre:2020
    },
    {
        id:2021,
        nombre:2021
    },
    {
        id:2022,
        nombre:2022
    }
],
     
     
         
         poa_lineas_accion:[]as any,
              poa_seriesdata:[] as any,
      
    }
  },
     mixins: [poa_series],
     validations: {
    
           ano: {
      required,
    },
    estatus: {
      required,
    },
 
     

   
  },
  methods:{
       clearstate(){
this.$store.commit('SETPOASERIE',null);
 this.$router.push('/mun/poa/series')
        },
      async eliminar(row){
         this.show=false;
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_POA_SERIES(row).then(response => {

                    if (response != null) {
 this.show=false;
 this.poa_seriesdata=this.poa_seriesdata.filter(item => item.id !== row.id);
 this.show=true;
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
    /* select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPOASERIE',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/poa/series/lineasaccion')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                 this.ano=null;
                 this.estatus=null;

        
    
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_poa_series').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.ano=row.ano;
 this.estatus=row.estatus;

            
          
 $('#ac_modal_poa_series').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_POA_SERIES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.poa_seriesdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Serie, refresque la pagina");

                    }    $("#ac_modal_poa_series").modal("hide");
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_POA_SERIES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
this.$root.$emit("success", "Poa Serie modificado exitosamente, refresque la pagina");
  this.poa_seriesdata=this.poa_seriesdata.filter(item => item.id !== dat.id);
 this.poa_seriesdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Serie, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
           
           ano:this.ano,
           estatus:this.estatus,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')
this.ano=2021;
this.estatus='Activo';
let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_POA_SERIES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_seriesdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

